import { LoadingIndicator } from '@abb/abb-common-ux-react';
import { useAuth } from 'oidc-react';
import * as React from 'react';
import { useEffect, useRef } from 'react';

import { Redirect, Route, useLocation } from 'react-router-dom';

import { isGranted } from '../../lib/abpUtility';
import { oidcConfig } from '../../lib/appconst';

declare var abp: any;

function isOidcCallbackPath(pathname: string): boolean {
  return (
    pathname.indexOf('/account/callback') >= 0 ||
    pathname.indexOf('/account/slientcallback') >= 0
  );
}

const SignIn = () => {
  const auth = useAuth();
  const user = auth?.userData;
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;

    // 回调处理中：URL 带 code，交给 AuthProvider，切勿再次 signIn
    const params = new URLSearchParams(window.location.search);
    if (isOidcCallbackPath(window.location.pathname) || params.has('code')) {
      return;
    }

    started.current = true;

    if (user && !user.expired) {
      oidcConfig.onSignIn(user);
      return;
    }

    auth.signIn();
  }, [auth, user]);

  return (
    <LoadingIndicator
      color="red"
      determinate={false}
      type="bar"
      value={0}
    />
  );
};

const ProtectedRoute = ({ path, component: Component, permission, render, ...rest }: any) => {
  const location = useLocation();
  const pathname = location?.pathname || window.location.pathname;

  // 必须用浏览器真实路径判断回调页（Route 的 path 配置经常是 "/"）
  if (isOidcCallbackPath(pathname)) {
    return (
      <LoadingIndicator
        color="red"
        determinate={false}
        type="bar"
        value={0}
      />
    );
  }

  const token = abp.auth.getToken();
  // 有 token 时不要 clearToken；无 token 才去登录
  if (!token && !abp.session.identiFierId) {
    return <SignIn />;
  }

  return (
    <Route
      {...rest}
      path={path}
      render={(props) => {
        if (permission && !isGranted(permission)) {
          return <Redirect to="/exception?type=403" />;
        }

        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
